import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField/TextField';
import globalContext from '../../../../config/context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 300,
  },
  textField: {
    width: '100%',
    paddingBottom: 10,
  },
}));

const DialogKetetapan = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();

  const {tahun, setTahun, onKetetapanPbb} = props;
  // console.log(pencarian.tahun);

  return (
    <div className={classes.root}>
      <TextField
        id="standard-number"
        className={classes.textField}
        label="Tahun"
        type="number"
        value={tahun ? tahun : pencarian.tahun}
        onChange={(e) => setTahun(e.target.value)}
        onInput={(e) => {
          e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4);
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onKetetapanPbb();
          }
        }}
      />
    </div>
  );
};

export default DialogKetetapan;
